module.exports = __webpack_public_path__ + "img/firebase.6caacd1a.svg";